// Lib
import React from 'react';
import PropTypes from 'prop-types';
import { branch } from '../../../node_module_clones/recompose';
import { identity } from 'lodash/fp';

// Utils
import platformSingleton from '../../platform/platformSingleton';

// Decorators
import selectionMarqueeStateDecorator from './selectionMarqueeStateDecorator';
import selectionMarqueeMouseEventHandlerDecorator from './selectionMarqueeMouseEventHandlerDecorator';
import selectionMarqueeSelectedElementFinderDecorator from './selectionMarqueeSelectedElementFinderDecorator';
import selectionMarqueeLongPressEventHandlerDecorator from './selectionMarqueeLongPressEventHandlerDecorator';

// Styles
import './SelectionMarquee.scss';

@selectionMarqueeStateDecorator
@selectionMarqueeSelectedElementFinderDecorator
@selectionMarqueeMouseEventHandlerDecorator
@branch(() => platformSingleton.features.isTouch, selectionMarqueeLongPressEventHandlerDecorator, identity)
class SelectionMarquee extends React.Component {
    getMarqueePositionStyle = () => {
        const { top, left, width, height } = this.props;
        return { top, left, width, height };
    };

    render() {
        if (!this.props.active) return null;
        return <div className="SelectionMarquee" style={this.getMarqueePositionStyle()} />;
    }
}

SelectionMarquee.propTypes = {
    active: PropTypes.bool,
    top: PropTypes.number,
    left: PropTypes.number,
    width: PropTypes.number,
    height: PropTypes.number,
};

export default SelectionMarquee;
